import { SessionStorageManager } from '@atlas/core';

export const LEAVING_POP_UP_STEP_KEY = 'leaving_pop_up_step';

export const getLeavingPopUpSteps = () =>
  SessionStorageManager.getItem(LEAVING_POP_UP_STEP_KEY) || null;

export const addLeavingPopUpStep = step => {
  if (step === null || step === undefined) return getLeavingPopUpSteps();

  const existing = getLeavingPopUpSteps();
  const steps = existing ? existing.split(',') : [];
  const value = String(step);

  if (!steps.includes(value)) steps.push(value);

  const next = steps
    .map(Number)
    .sort((a, b) => a - b)
    .join(',');

  SessionStorageManager.setItem(LEAVING_POP_UP_STEP_KEY, next);

  return next;
};

export const clearLeavingPopUpSteps = () =>
  SessionStorageManager.removeItem(LEAVING_POP_UP_STEP_KEY);
